import React from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "@/providers";
import Router from "@/routes/Router";
import { initSentry } from "@settings/sentry";
import "@/global.css";

initSentry();

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Providers>
      <Router />
    </Providers>
  </React.StrictMode>
);
